import './App.css';
import ReactDOM from 'react-dom';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import React, {createContext, useEffect, useState, useRef } from "react";
import DashBoard from './components/dashboard/DashBoard';
import TopBar from './components/topbar/TopBar';
import Visitorlist from "./components/visitor/visitorlist";
import Vehicle from "./components/vehicle/vehiclelist.js";
import Courier from "./components/courier/courierlist.js";
import Courierview from "./components/courier/courierview.js";
import Vehicleview from "./components/vehicle/vehicleview.js";
import Vehicleadd from "./components/vehicle/vehicleadd.js";
import Courieradd from "./components/courier/courieradd.js";
import Visitoradd from "./components/visitor/visitorlist.js";
import Report from "./components/report/report.js"
import { VisitorCreate } from './components/visitor/visitor-create/visitor-create';
import VisitorView from './components/visitor/visitor-view/visitor_view_1.js';
import { VehicleCreate } from './components/vehicle/vehicle-create/vehicle-create.js';
import VehicleView from './components/vehicle/vehicle-view/vehicle_view.js';
import { CourierCreate } from './components/courier/courier-create/courier-create.js';
import CourierView from './components/courier/courier-view/courier_view.js';
import { WhatsAppTemplateCreate } from './components/whatsapp-template/whatsapp-template-create.js';
import { TemplateCreate } from './components/whatsapp-template/template-create.js';
import { TabProvider } from './components/common/context/tabcontext.js';
import SideBar from './components/sidebar/sidebar.js';
import Vehiclemaster from './components/masters/vehiclemaster/vehiclemasterlist.js';
import Gatemaster from './components/masters/gatemaster/gatemasterlist.js';
import Purposeofvisit from './components/masters/purposeofvisit/purposeofvisitlist.js';
import Checklist from './components/masters/checklist/checklistlist.js';
import Template from './components/masters/template/templatelist.js';
import Whatsapptemplate from './components/masters/whatsapptemplate/whatsapptemplatelist.js';
import Alertconfiguration from './components/masters/alertconfiguration/alertconfigurationlist.js';
import Registerfields from './components/masters/registerfields/registerfieldslist.js';
import { useGlobal } from "./GlobalContext";
import { getCookie } from "./components/getcookie";
import axios from "axios";
import PreLanding from './pre-landing.js';
import HelpQuestions from './components/common/help.js';





// import { TabProvider } from "./common/context/tabContext";

// Create a context
export const TimeContext = createContext();







function App() {
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;

  const { rolePermissionList, setRolePermissionList, userType, setUserType } = useGlobal();

    useEffect(() => {

      getRolePermission();
    }, []);
  
    const getRolePermission = async () => {
       
        try {
          const response = await axios.get(adminApiUrl+"get_role_permission/10", {
            params: { },
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                "Accept": "application/json",      
                "Access-Control-Allow-Origin": "*", // Required for CORS support to work
                 "Authorization":getCookie("mawalog")
              }
          }).then((response) => {
            if(response.status===200){
                if (response.data.success === true) {
                  setUserType(response.data.user_type);
                  setRolePermissionList(response.data.role_permission??[]); 
                  localStorage.setItem("rolePermissionList", JSON.stringify(response.data.role_permission??[]));
                  localStorage.setItem("userType", response.data.user_type??'');  
                  console.log('lsr',localStorage.getItem("rolePermissionList"))
                  console.log('lsu',localStorage.getItem("userType"))
                               
                }else{
                  setRolePermissionList([]);
                }
            }
          }).catch((error) => {
            if (error.response) {
              console.error("Error Status:", error.response.status);
              console.error("Error Data:", error.response.data);
              if(error.response.status===401){ 
                document.cookie = 'redirectPath=' + window.location.href + '; path=/; domain=.mawalog.com';
                document.cookie = 'mawalog=; path=/; domain=.mawalog.com';
                window.location.href = accountsUrl;
                }
            } else {
              console.error("Request failed:", error.message);
            }
          });;
    
         // const data = await response.json();
        
        } catch (err) {
          console.error("Error fetching floors:", err);
        
        } finally {
          
        }
      };

  return (
    <TabProvider>
      <div className="App">
      <BrowserRouter>
        <Routes>
           <Route path="/" element={<PreLanding />} />
          <Route path="/dashboard" element={<DashBoard />} />
          <Route path="/visitors" element={<Visitorlist />} />
          <Route path="/vehicle" element={<Vehicle />} />
          <Route path="/courier" element={<Courier />} />
          <Route path="/courier/add" element={<Courieradd />} />
          <Route path="/visitor/add" element={<Visitoradd />} />
          <Route path="/vehicle/add" element={<Vehicleadd />} />
          <Route path="/courier/view" element={<Courierview />} />
          <Route path="/vehicle/view" element={<Vehicleview />} />
          <Route path="/report" element={<Report/>}></Route>
          <Route path='/gatemasters' element={<Gatemaster />} />
           <Route path='/vehiclemasters' element={<Vehiclemaster />} />
           <Route path='/purposeofvisit' element={<Purposeofvisit />} />
           <Route path='/checklist' element={<Checklist />} />
           <Route path='/template' element={<Template />} />
           <Route path='/whatsapptemplate' element={<Whatsapptemplate />} />
           <Route path='/alertconfiguration' element={<Alertconfiguration />} />
           <Route path='/registerfields' element={<Registerfields />} />








          <Route path="/visitor-create" element={<VisitorCreate />}></Route>
          <Route path="/visitor-view" element={<VisitorView />}></Route>
          <Route path="/vehicle-create" element={<VehicleCreate />}></Route>
          <Route path="/vehicle-view" element={<VehicleView />}></Route>
          <Route path="/courier-create" element={<CourierCreate />}></Route>
          <Route path="/courier-view" element={<CourierView />}></Route>
        <Route path="/whatsapp-create" element={<WhatsAppTemplateCreate/>}></Route>
        <Route path="/template-create" element={<TemplateCreate/>}></Route>
        <Route path="/help" element={<HelpQuestions/>}></Route>
        </Routes>
        </BrowserRouter>
      </div>
    </TabProvider>
  );
}

export default App;
